<template>
  <div class="row">
    <div class="col-sm-6">
      <textarea
        rows="10"
        class="form-control"
        v-model="wikiText"/>
      <hr>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="resource uuid"
          v-model="resourceId">
        <span class="input-group-btn">
          <button
            class="btn btn-default"
            type="button"
            @click="addResource">Add resource</button>
        </span>
      </div>
      <br>
      <ul class="list-group">
        <li
          class="list-group-item"
          v-for="uuid in resourceUuids"
          :key="uuid">{{ uuid }}</li>
      </ul>
    </div>
    <div class="col-sm-6">
      <wiki-text
        :text="wikiText"
        :plaintext="options.plaintext"
        :popover-placement="options.popoverPlacement"
        :strategies="options.strategies"
        :resources="options.resources" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { getStrategies } from '@/api/strategies'
import { getResource } from '@/api/pathways'
import WikiText from '@/components/WikiText'
export default {
  name: 'WikiTextPreview',
  components: {
    WikiText
  },
  data() {
    return {
      wikiText: `## Follow along as I read the story <u>The Lion and the Mouse</u> out loud.

*Teacher does a read aloud of story with students following along*

Place the picture cards from the story in the correct order from beginning, middle to end using the [[ eeea79d1-04f2-4756-78c6-64e0ca38e237 | story sequence mat ]] and retell each part of the story.

Oooo look some [[ graph paper | graph paper aww yeah ]]

`,
      options: {
        plaintext: false,
        popoverPlacement: 'right',
        strategies: {},
        resources: {}
      },
      resourceId: 'eeea79d1-04f2-4756-78c6-64e0ca38e237'
    }
  },
  computed: {
    resourceUuids() {
      return Object.keys(this.options.resources)
    }
  },
  methods: {
    getStrategies() {
      getStrategies({ published: true, size: 400 }).then(strategies => {
        strategies = strategies.hits.hits.map(strategy => {
          return strategy._source
        })
        strategies.forEach(strategy => {
          Vue.set(this.options.strategies, strategy.title.toLowerCase(), strategy)
        })
      })
    },
    addResource() {
      if (this.resourceId) {
        getResource(this.resourceId)
          .then(resource => {
            Vue.set(this.options.resources, resource.uuid, resource)
          })
          .catch(err => {
            console.error(err)
          })
        this.resourceId = ''
      }
    }
  },
  created() {
    this.getStrategies()
    this.addResource()
  }
}
</script>
